import { instance } from "libs/api";

import { ApiRoutesAuth } from "./../../constants";

export const requestLogout = async () => {
  return await instance.post(ApiRoutesAuth.Logout);
};
